import { render } from "./TabChangePassword.vue?vue&type=template&id=425a9fc8"
import script from "./TabChangePassword.js?vue&type=script&lang=js"
export * from "./TabChangePassword.js?vue&type=script&lang=js"

import "./TabChangePassword.scss?vue&type=style&index=0&lang=scss&scope=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__